const CATEGORY_LABELS: Record<string, string> = {
  graphic: "Graphic",
  video: "Video",
  webui: "Web & UI",
};

export function categoryLabel(category: null | string): string {
  return (category && CATEGORY_LABELS[category]) || "—";
}
